<template>
<div class="container">
    <ais-instant-search 
    index-name="movies" 
    :search-client="searchClient" 
    :search-function="searchFunction"
    :initial-ui-state="initialUiState"
    :routing="routing">
    <ais-configure :hits-per-page.camel="30"/>
    <div class="columns">
        <div class="column is-one-quarter is-size-5">
          <form class="-card has-background-grey-dark">
            <div class="-card">
              <div class="-card-content">
                <div class="field">
                  <div class="control">
                    <ais-refinement-list attribute="genres" operator="and">
                      <div
                          slot-scope="{
                            items,
                            refine,
                            createURL
                          }"
                        >
                          <!-- <ul v-if="!items.length">
                            <li><a href="#" @click.prevent="refine('Drama')"><span class="ais-Highlight">Drama</span> (7,515)</a></li>
                            <li><a href="#" @click.prevent="refine('Horror')"><span class="ais-Highlight">Horror</span> (2,831)</a></li>
                            <li><a href="#" @click.prevent="refine('Comedy')"><span class="ais-Highlight">Comedy</span> (2,831)</a></li>
                          </ul>
                          <ul v-else>
                            <li v-if="!items.length">No results.</li>
                            <li v-for="item in items" :key="item.value">
                              <a
                                :href="createURL(item)"
                                :style="{ fontWeight: item.isRefined ?  'bold' : '' }"
                                @click.prevent="refine(item.value)"
                              >
                                <ais-highlight attribute="item" :hit="item"/>
                                ({{ item.count.toLocaleString() }})
                              </a>
                            </li>
                          </ul> -->
                        </div>
                    </ais-refinement-list>
                  </div>
                </div>
                <hr>
                <div class="field">
                  <div class="control">
                    <ais-range-input attribute="release_year" :min="yearMin" :max="yearMax">
                      <span slot="submitLabel">Release year</span>
                    </ais-range-input>
                  </div>
                </div>
                <hr>
                <div class="field">
                  <div class="control">
                    <ais-range-input attribute="rating_imdb" :min="imdbMin" :max="imdbMax">
                      <span slot="submitLabel">IMDB rating</span>
                    </ais-range-input>
                  </div>
                </div>
                <hr>
                <div class="field">
                  <div class="control">
                    <label class="label is-size-6">Sex</label>
                    <ais-numeric-menu
                        attribute="rating_thrillter_nudity"
                        :items="[
                        { label: 'Whatever' },
                        { label: 'Some', start: 40, end: 100 },
                        { label: 'Loads', start: 60, end: 100 }
                        ]">
                        <div class="control" slot-scope="{ items, refine, createURL }">
                          <label class="radio" v-for="item in items" :key="item.value">
                            <input type="radio" name="sex" :checked="item.isRefined" @click.prevent="refine(item.value)"> {{item.label}}
                          </label>
                        </div>
                    </ais-numeric-menu>
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label is-size-6">Slayings</label>
                    <ais-numeric-menu
                        attribute="rating_thrillter_violence"
                        :items="[
                        { label: 'Whatever' },
                        { label: 'Some', start: 40, end: 100 },
                        { label: 'Loads', start: 60, end: 100 }
                        ]">
                        <div class="control" slot-scope="{ items, refine, createURL }">
                          <label class="radio" v-for="item in items" :key="item.value">
                            <input type="radio" name="slayings" :checked="item.isRefined" @click.prevent="refine(item.value)"> {{item.label}}
                          </label>
                        </div>
                    </ais-numeric-menu>
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <label class="label is-size-6">Scares</label>
                    <ais-numeric-menu
                        attribute="rating_thrillter_frightening"
                        :items="[
                        { label: 'Whatever' },
                        { label: 'Some', start: 40, end: 100 },
                        { label: 'Loads', start: 60, end: 100 }
                        ]">
                        <div class="control" slot-scope="{ items, refine, createURL }">
                          <label class="radio" v-for="item in items" :key="item.value">
                            <input type="radio" name="scares" :checked="item.isRefined" @click.prevent="refine(item.value)"> {{item.label}}
                          </label>
                        </div>
                    </ais-numeric-menu>
                  </div>
                </div>
                <hr>
                <div class="field">
                  <div class="control">
                    <ais-toggle-refinement attribute="providers_stream_available" operator="or" label="Subscription streaming" />
                  </div>
                </div>
                <div class="field">
                  <div class="control">
                    <ais-toggle-refinement attribute="providers_rent_available" operator="or" label="Rental streaming"/>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="column">
            <div class="columns">
              <div class="column is-9">
                  <ais-search-box placeholder="Search movie title, actor, director, keywords, etc" :autofocus="true" />
              </div>
              <div class="column">
                  <ais-stats/>                      
              </div>
            </div>
            <div class="columns">
              <div class="column">
                <ais-hits>
                <div slot-scope="{ items }" v-observe-visibility="contentLoaded">
                    <div class="columns is-multiline">
                      <div class="column is-one-fifth" v-for="item in items" :key="item.objectID">
                          <div class="card has-background-grey-dark has-text-light" style="height:100%;">
                            <div class="card-image">
                                <figure class="image">
                                  <router-link :to="`/movies/${item.release_year}/${item.slug}`">
                                    <img :src="`https://image.tmdb.org/t/p/w154${item.poster_path}`"/>
                                  </router-link>
                                </figure>
                            </div>
                            <div class="card-content">
                                <div class="content">
                                  <div class="rating-box-list">
                                      <div class="rating-box">{{round(item.rating_thrillter_overall)}}</div>
                                      <div class="rating-box">{{round(item.rating_thrillter_nudity)}}</div>
                                      <div class="rating-box">{{round(item.rating_thrillter_violence)}}</div>
                                      <div class="rating-box">{{round(item.rating_thrillter_frightening)}}</div>
                                      <div class="rating-box">{{item.rating_imdb}}</div>
                                  </div>
                                  <p class="title-with-year"><router-link :to="`/movies/${item.release_year}/${item.slug}`">{{ item.title_with_year }}</router-link></p>
                                  <p v-if="availableForStreaming(item)" class="tag is-success"><i class="fas fa-tv"></i>&nbsp;Streaming available</p>
                                </div>
                            </div>
                          </div>
                      </div>
                    </div>
                </div>
                </ais-hits>
                <div class="pagination-container">
                  <ais-pagination />
                </div>
                <Footer></Footer>
              </div>
            </div>
        </div>
    </div>
    </ais-instant-search>
    </div>
</template>
<script>
import algoliasearch from 'algoliasearch/lite';
import { history as historyRouter } from '../router/algolia';
import { singleIndex as singleIndexMapping } from 'instantsearch.js/es/lib/stateMappings';
import 'instantsearch.css/themes/algolia-min.css';
import Footer from './Footer.vue';
import initialHitsFromFile from "../../public/initial-hits.json";
const algoliaClient = algoliasearch(
  '2U8HR75L7O',
  'b2dfc84bbbce1659944bd30b75b68245'
);
const thrillterSearchClient = {
  search(requests) {
    if (requests.every(({ params }) => !params.query)) {
      return Promise.resolve({
        results: requests.map(() => ({
          hits: initialHitsFromFile,
          nbHits: 0,
          nbPages: 0,
          page: 0,
          processingTimeMS: 0,
        })),
      });
    }
    return algoliaClient.search(requests);
  }
};
export default {
  components: {
    Footer
  },
  props: {
    scrollPos: Number,
    imageBaseUrl: String
  },
  data() {
    return {
      routing: {
        router: historyRouter(),
        stateMapping: singleIndexMapping('movies'),
      },      
      // searchClient: algoliasearch(
      //   '2U8HR75L7O',
      //   'b2dfc84bbbce1659944bd30b75b68245'
      // ),
      searchClient: thrillterSearchClient,
      initialUiState: {
        movies: {
          // query: 'cult',
          // refinementList: {
          //   genres: ['Horror']
          // },
          // range: {
          //   rating_imdb: '3.0:5.0',
          //   release_year: '1975:1995',
          // },
        }
      },
      yearMin: 1960,
      yearMax: 2009,
      imdbMin: 3,
      imdbMax: 7
    };
  },  
  created: function() {
    //window.addEventListener('scroll', this.onScroll);
  },
  destroyed () {
    //window.removeEventListener('scroll', this.onScroll);
  },
  methods: {
    contentLoaded: function() {
      //document.documentElement.scrollTop = this.scrollPos;
    },
    // onScroll: function() {
    //   this.$emit('scroll', window.scrollY);
    // },
    toValue(value, range) {
      return [
        value.min !== null ? value.min : range.min,
        value.max !== null ? value.max : range.max,
      ];
    },    
    availableForStreaming(item) {
      return item.providers_stream_available || item.providers_rent_available
    },
    // checkLocalStorageForInitialState() {

    // },
    searchFunction(helper) {
      //console.log(helper.state);
      helper.search();
    },
    round(value) {
      return Math.round(value);
    },
    doRefine($event) {
      this.refine({ min: $event[0], max: $event[1] })
    },
  }
}
</script>
<style scoped>
.container {
  padding-top:25px;
}
form {
    background-color: #fff;
    border-radius: .25rem;
    box-shadow: 0 0.5em 1em -0.125em rgba(10,10,10,.1), 0 0 0 1px rgba(10,10,10,.02);
    color: #4a4a4a;
    max-width: 100%;
    overflow: hidden;
    padding:1em;
}
.title-with-year {
  margin:10px 0 0 0;
  font-weight:bold;
}

.pagination-container {
  margin:20px 0;
}

        .rating-box-list {
            display:flex;
            flex-direction:row;
            justify-content:center; 
            align-items:center;
            }
    
        .rating-box {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 30px;
            height: 30px;
            margin:0 2px;
            border:3px solid pink;
            border-radius: 100%;
            font-size:14px;
            }
</style>        